// extracted by mini-css-extract-plugin
module.exports = {"Cells":"Cells_Cells__2IQyg"};